import React, { useEffect, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import About from './pages/About';
import Publications from './pages/Publications';
import Projects from './pages/Projects';
import Portfolio from './pages/Portfolio';
import Writings from './pages/Writings';
import CV from './pages/CV';
import CaseStudy from './pages/CaseStudy';
import DIXTRALCaseStudy from './pages/DIXTRALCaseStudy';
import VRExergamesCaseStudy from './pages/VRExergamesCaseStudy';
import AnchorCaseStudy from './pages/AnchorCaseStudy';

function App() {
  const nextEligibleAtRef = useRef<number>(Date.now());
  useEffect(() => {
    const getRandomIntervalMs = () => 60000 + Math.floor(Math.random() * 120000); // 1–3 minutes
    // Delay first eligible popup by a random interval
    nextEligibleAtRef.current = Date.now() + getRandomIntervalMs();

    const handleClick = (e: MouseEvent) => {
      if (window.innerWidth < 900) return; // Only on desktop
      // Only show popup if cooldown elapsed
      if (Date.now() < nextEligibleAtRef.current) return;
      // Set next eligible time after showing
      nextEligibleAtRef.current = Date.now() + getRandomIntervalMs();
      // Hire Me! popup
      const popup = document.createElement('div');
      popup.className = 'hireme-popup';
      popup.textContent = 'Hire Me!';
      popup.style.left = `${e.clientX - 50}px`;
      popup.style.top = `${e.clientY - 40}px`;
      document.body.appendChild(popup);
      setTimeout(() => popup.remove(), 1200);
      // Confetti burst
      const colors = ['#2563eb', '#ffe066', '#ff5e57', '#43d9ad', '#a259ec', '#f7b801'];
      for (let i = 0; i < 18; i++) {
        const conf = document.createElement('div');
        conf.className = 'confetti-piece';
        conf.style.background = colors[Math.floor(Math.random() * colors.length)];
        conf.style.left = `${e.clientX - 5}px`;
        conf.style.top = `${e.clientY - 5}px`;
        const angle = (Math.PI * 2 * i) / 18;
        const dx = Math.cos(angle) * (40 + Math.random() * 40);
        const dy = Math.sin(angle) * (40 + Math.random() * 40);
        conf.style.setProperty('--dx', `${dx}px`);
        conf.style.setProperty('--dy', `${-dy}px`);
        document.body.appendChild(conf);
        setTimeout(() => conf.remove(), 1200);
      }
    };
    window.addEventListener('click', handleClick);
    return () => window.removeEventListener('click', handleClick);
  }, []);

  return (
    <Router>
      <div className="App">
        <a href="#main-content" className="skip-link">Skip to main content</a>
        <Navbar />
        <main id="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/publications" element={<Publications />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/writings" element={<Writings />} />
            <Route path="/cv" element={<CV />} />
            <Route path="/case-study/dixtral" element={<DIXTRALCaseStudy />} />
            <Route path="/case-study/vr-exergames" element={<VRExergamesCaseStudy />} />
            <Route path="/case-study/anchor" element={<AnchorCaseStudy />} />
            <Route path="/case-study/:id" element={<CaseStudy />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
